import React from 'react';
import { Steps, Tag, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { formatInstant } from '../../format.js';
import { runDuration, runErrorText, runState, runTitle, visibleSteps } from '../../businessDay/businessDay.js';

const { Text } = Typography;

/**
 * What analytics did with one version's files (IP-163): its runs, the file
 * runs first in feed order, then the runs they chained - each with its state,
 * when it started, how long it took, its steps, and why it failed (M4). Pure
 * over the read.
 *
 * @param {{ rows: object[], chainedRuns?: object[] }} props rows: the version's feedRows
 */
export const AnalyticsRuns = ({ rows, chainedRuns = [] }) => {
    const items = [
        ...rows.flatMap((row) => (row.analytics?.runs ?? []).map((run) => ({ run, from: row.label }))),
        ...chainedRuns.map((run) => ({ run, from: null }))
    ];
    if (!items.length) return null;
    return (
        <div className="analytics-feeds-runs">
            <p className="business-day-meta">Analytics processing</p>
            {items.map(({ run, from }) => {
                const state = runState(run);
                return (
                    <div key={run.stateMachine + '/' + run.executionName} className="analytics-feeds-run">
                        <div className="analytics-feeds-run-head">
                            <Text strong>{runTitle(run)}</Text>
                            {from && <Text type="secondary">from the {from.toLowerCase()} file</Text>}
                            <Tag color={state.colour} icon={run.status === 'RUNNING' ? <LoadingOutlined /> : null}>{state.label}</Tag>
                            <Text type="secondary">{formatInstant(run.startedAt)}{run.stoppedAt ? ' · ' + runDuration(run) : ''}</Text>
                        </div>
                        <Steps size="small" className="analytics-feeds-steps" items={visibleSteps(run)} />
                        {run.error && <ul className="analytics-feeds-problems"><li>{runErrorText(run.error)}</li></ul>}
                    </div>
                );
            })}
        </div>
    );
};

export default AnalyticsRuns;
